module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.b67406e0.png";